"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MapboxResult {
    constructor(location) {
        this.id = location.id;
        this.setGeometry(location);
        this.setProperties(location);
        this.setNames(location);
        this.setDropdownProperties();
    }
    setGeometry(location) {
        const [lng, lat] = location.geometry.coordinates;
        this.latitude = lat;
        this.longitude = lng;
    }
    setProperties(location) {
        const locations = [location];
        if (location.context) {
            locations.push(...location.context);
        }
        locations.forEach((entry) => this.setPropertyFrom(entry));
    }
    setPropertyFrom(location) {
        if (this.isA("place", location)) {
            this.city = location.text;
        }
        if (this.isA("postcode", location)) {
            this.postal_code = location.text;
        }
        if (this.isA("region", location)) {
            this.state_long_name = location.text;
            this.state_short_name = this.getShortCode(location);
        }
        if (this.isA("country", location)) {
            this.country_long_name = location.text;
            this.country_short_name = this.getShortCode(location);
        }
    }
    isA(locationType, location) {
        return location.id.includes(locationType) || (location.place_type && location.place_type.includes(locationType));
    }
    setNames(location) {
        let { place_name: placeName } = location;
        if (location.text) {
            // Override place name only if
            // 1. It's not the same word for place, state and country
            // 2. There's a city already set
            if (this.city && this.state_long_name && this.country_long_name) {
                if (this.city !== this.state_long_name || this.state_long_name !== this.country_long_name) {
                    placeName = [location.text, this.state_long_name, this.country_long_name].join(", ");
                }
                this.city = location.text;
            }
        }
        this.displayName = placeName;
        this.name = placeName;
    }
    getShortCode(data) {
        let shortCode;
        const { properties } = data;
        if (properties === null || properties === void 0 ? void 0 : properties.short_code) {
            shortCode = properties.short_code;
        }
        else {
            shortCode = data.short_code || "";
        }
        if (shortCode.includes("-")) {
            [, shortCode] = shortCode.split(/-/);
        }
        return shortCode.toUpperCase();
    }
    setDropdownProperties() {
        this.label = this.displayName;
        this.value = this.id;
    }
}
exports.default = MapboxResult;
